<template>
  <div class="card custom-card mt-4">
    <div class="support">
      <div class="col-md-7">
        <h2>Contact Us</h2>
        <form @submit.prevent="sendMessage">
          <div style="position:relative">
            <div class="form-group m-label-left">
              <textarea
                id="desc"
                type="text"
                class="form-control"
                v-model="info.description"
                rows="8"
                placeholder="Describe your issue"
              ></textarea>
              <label class="sr-only" for="desc">Issue</label>
            </div>
            <div class="mb-3 mt-4">
              <label for="formFile" class="form-label"
                >Upload screenshot (optional - jpg, png, jpeg, pdf, doc, docx)</label
              >
              <input
                class="form-control"
                type="file"
                id="formFile"
                ref="fileInput"
                @change="handleFileChange($event)"
                accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
              />
            </div>
            <Spinner :isLoading="isLoading" />
          </div>
          <div class="d-flex">
            <div class="buttons">
              <button
                :disabled="!info.description.length || isLoading"
                type="submit"
                class="btn btn-primary"
              >
                Send
              </button>
              <button
                :disabled="!info.description.length || isLoading"
                type="button"
                @click="resetForm"
                class="btn btn-secondary"
              >
                Reset
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [titleMixin],
  title() {
    return 'Support | Jobshark';
  },
  components: {},
  data: () => ({
    isLoading: false,
    info: {
      description: '',
      file: '',
      name: '',
      email: '',
      type: '',
      employer: null,
      route: 'manager',
    },
  }),
  methods: {
    ...mapActions('managerStoreModule', ['retrieveManagerProfile', 'retrieveManagerUserProfile']),
    ...mapActions(['retrieveCandidateUserProfile']),
    handleFileChange(event) {
      let maxSize = 2 * 1024 * 1024;
      if (event.target.files[0].size <= maxSize) {
        this.info.file = event.target.files[0]; // Assuming you only want to handle a single file
      } else {
        this.$refs.fileInput.value = '';
        this.$toasted.error('The file size exceeds the limit of 2MB.', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
      }
    },
    sendMessage() {
      if (this.info.description.length === 0) {
        this.$toasted.error('Please, describe your issue first.', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      }
      this.isLoading = true;
      const formData = new FormData();
      formData.append('image', this.info.file);
      formData.append('name', this.info.name);
      formData.append('email', this.info.email);
      formData.append('description', this.info.description);
      formData.append('type', this.info.type);
      formData.append('employer', this.info.employer);
      axios
        .post(`${process.env.VUE_APP_API_URL}/${this.info.route}/support/sendmail`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.resetForm();
          this.isLoading = false;
          this.$toasted.success('Thanks for contacting us. Your message was sent successfully!', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.isLoading = false;
          this.$toasted.error('Unfortunately, there was an a problem to send your message.', {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    resetForm() {
      this.$refs.fileInput.value = '';
      this.info.description = '';
      this.info.file = '';
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerProfile', 'getManagerUserProfile']),
    ...mapGetters(['getAccType', 'getUserProfile']),
  },
  mounted() {
    if (this.getAccType === 'manager') {
      this.retrieveManagerProfile().then(() => {
        this.info.name = `${this.getManagerProfile.first_name} ${this.getManagerProfile.last_name}`;
        this.info.email = this.getManagerProfile.email;
        this.info.type = 'manager';
        this.info.employer = this.getManagerProfile.employer_name;
      });
    } else if (this.getAccType === 'user') {
      this.retrieveManagerUserProfile().then(() => {
        this.info.name = `${this.getManagerUserProfile.first_name} ${this.getManagerUserProfile.last_name}`;
        this.info.email = this.getManagerUserProfile.email;
        this.info.type = 'user';
        this.info.employer = this.getManagerUserProfile.employer_name;
      });
    } else {
      this.retrieveCandidateUserProfile().then(() => {
        this.info.name = `${this.getUserProfile.first_name} ${this.getUserProfile.last_name}`;
        this.info.email = this.getUserProfile.email;
        this.info.type = 'candidate';
        this.info.route = 'candidate';
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.card {
  margin-left: 28px;
  margin-right: 28px;
  min-height: calc(100vh - 140px);
  .support {
    padding: 30px 12px 30px 12px;
    h4 {
      font-weight: 600;
      margin-bottom: 20px;
    }
    .buttons {
      margin-left: auto;
      .btn-primary {
        margin-right: 12px;
      }
    }
  }
}

[type='file'] {
  border: 1px solid #ddd !important;
  clip: rect(0, 0, 0, 0);
  height: 37px !important;
  overflow: visible !important;
  padding: 0.375rem 0.75rem !important;
  position: relative !important;
  white-space: nowrap;
  width: 100% !important;
}
</style>
